export const GET_DOCUMENT_ATTRIBUTES = 'attributes/GET_DOCUMENT_ATTRIBUTES'
export const SET_DOCUMENT_ATTRIBUTES = 'attributes/SET_DOCUMENT_ATTRIBUTES'

export const GET_TECHNICAL_LIFECYCLES_ATTRIBUTES = 'attributes/GET_TECHNICAL_LIFECYCLES_ATTRIBUTES'
export const SET_TECHNICAL_LIFECYCLES_ATTRIBUTES = 'attributes/SET_TECHNICAL_LIFECYCLES_ATTRIBUTES'
